import React, { useState } from 'react';
import { Phone, Instagram, MapPin, ChevronDown, ChevronUp, MessageCircle } from 'lucide-react';

const ContactFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "Berapa kapasitas maksimal Villa Difa BallaEja?",
      a: "Sesuai dengan fasilitas kami, villa ini dapat menampung rombongan dengan kapasitas 15 hingga 20 orang secara nyaman."
    },
    {
      q: "Apa saja objek wisata yang dekat dengan lokasi villa?",
      a: "Lokasi kami sangat strategis, hanya berjarak 500m dari Kampoeng Eropa, 600m dari The River, dan sekitar 5km dari Malino Highlands."
    },
    {
      q: "Apakah tersedia fasilitas dapur dan alat masak?",
      a: "Ya, kami menyediakan fasilitas dapur lengkap untuk kebutuhan memasak tamu selama menginap."
    },
    {
      q: "Bagaimana dengan ketersediaan koneksi internet?",
      a: "Kami menyediakan fasilitas Free WiFi untuk memastikan Anda tetap terhubung selama berlibur di Malino."
    },
    {
      q: "Apakah Ada Speaker dan Mic?",
      a: "Kami memiliki fasilitas Soundsistem yang lengkap "
    }
  ];

  return (
    <div className="bg-white font-poppins">
      {/* SECTION: FAQ */}
      <section className="py-20 px-6 lg:px-24">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-red-600 font-bold tracking-[0.3em] uppercase text-xs mb-4">Common Questions</h2>
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-6">F.A.Q</h1>
            <div className="w-20 h-1 bg-red-600 mx-auto"></div>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border border-gray-100 rounded-sm overflow-hidden transition-all">
                <button 
                  className="w-full flex justify-between items-center p-6 text-left bg-gray-50 hover:bg-gray-100 transition-colors"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="font-bold text-gray-800 text-sm md:text-base">{faq.q}</span>
                  {openIndex === index ? <ChevronUp className="text-red-600" /> : <ChevronDown className="text-gray-400" />}
                </button>
                {openIndex === index && (
                  <div className="p-6 bg-white text-gray-500 text-sm leading-relaxed animate-fade-in">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION: CONTACT & FOOTER */}
      <footer className="bg-gray-900 text-white pt-20 pb-10 px-6 lg:px-24">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-16 mb-20">
          
          {/* Brand Info */}
          <div className="space-y-6">
            <h2 className="text-3xl font-serif font-bold tracking-tighter">
              DIFA <span className="text-red-600">BALLAEJA</span>
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed">
              Pengalaman menginap tak terlupakan di Batu Lapisi Malino dengan pemandangan sawah, kabut, dan sunset yang memukau.
            </p>
            <div className="flex space-x-4">
              <a href="https://instagram.com/ballaeja" className="p-3 bg-white/5 hover:bg-red-600 transition-all rounded-full">
                <Instagram size={20} />
              </a>
              <a href="https://wa.me/62811412674" className="p-3 bg-white/5 hover:bg-green-600 transition-all rounded-full">
                <MessageCircle size={20} />
              </a>
            </div>
          </div>

          {/* Quick Contact */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold uppercase tracking-widest border-b border-red-600 pb-2 inline-block">Hubungi Kami</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-4">
                <Phone className="text-red-600 shrink-0" size={20} />
                <span className="text-gray-400 text-sm">0811412674</span>
              </li>
              <li className="flex items-start space-x-4">
                <Phone className="text-red-600 shrink-0" size={20} />
                <span className="text-gray-400 text-sm">082196694854</span>
              </li>
              <li className="flex items-start space-x-4">
                <Phone className="text-red-600 shrink-0" size={20} />
                <span className="text-gray-400 text-sm">085345526664</span>
              </li>
              <li className="flex items-start space-x-4">
                <Instagram className="text-red-600 shrink-0" size={20} />
                <span className="text-gray-400 text-sm">@ballaeja</span>
              </li>
              <li className="flex items-start space-x-4">
                <MapPin className="text-red-600 shrink-0" size={20} />
                <span className="text-gray-400 text-sm">Batu Lapisi Malino, Sulawesi Selatan</span>
              </li>
            </ul>
          </div>

          {/* Newsletter / CTA */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold uppercase tracking-widest border-b border-red-600 pb-2 inline-block">Siap Berlibur?</h3>
            <p className="text-gray-400 text-sm">Dapatkan harga khusus *Weekday Discount 25%* untuk pemesanan hari ini.</p>
            <a 
              href="/booking" 
              className="block w-full bg-red-600 hover:bg-white hover:text-red-600 text-center py-4 font-bold tracking-widest transition-all text-xs"
            >
              PESAN SEKARANG
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="max-w-7xl mx-auto border-t border-white/5 pt-10 text-center">
          <p className="text-gray-500 text-[10px] uppercase tracking-[0.5em]">
            © 2025 Difa BallaEja Malino. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ContactFAQ;